import styles from './BoardMenuPopoverSkeleton.less';

export const BoardMenuPopoverSkeleton = () => (
  <div className={styles.skeletonWrapper}>
    <div className={styles.skeletonPopoverOption} />
    <hr />
    <div className={styles.skeletonPopoverOption} />
    <div className={styles.skeletonPopoverOption} />
    <div className={styles.skeletonPopoverOption} />
    <div className={styles.skeletonPopoverOption} />
    <hr />
    <div className={styles.skeletonPopoverOption} />
    <div className={styles.skeletonPopoverOption} />
    <div className={styles.skeletonPopoverOption} />
    <div className={styles.skeletonPopoverOption} />
    <div className={styles.skeletonPopoverOption} />
    <hr />
    <div className={styles.skeletonPopoverOption} />
    <div className={styles.skeletonPopoverOption} />
    <div className={styles.skeletonPopoverOption} />
  </div>
);
